import { render, staticRenderFns } from "./RestrictionSalesPeriodEnabled.vue?vue&type=template&id=e957021c&scoped=true&"
import script from "./RestrictionSalesPeriodEnabled.vue?vue&type=script&lang=js&"
export * from "./RestrictionSalesPeriodEnabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e957021c",
  null
  
)

export default component.exports